import React from 'react';
import { RefreshCw } from 'lucide-react';

interface SyncProgressBarProps {
  isSyncing: boolean;
  message?: string;
  progress?: {
    current: number;
    total: number;
  };
}

export const SyncProgressBar: React.FC<SyncProgressBarProps> = ({
  isSyncing,
  message = 'Syncing...',
  progress
}) => {
  if (!isSyncing) return null;

  const progressPercentage = progress && progress.total > 0
    ? Math.round((progress.current / progress.total) * 100)
    : 0;

  const displayMessage = progress
    ? `${message} ${progress.current}/${progress.total} products`
    : message;

  return (
    <div className="mb-4 bg-blue-50 border border-blue-200 rounded-md p-4" data-testid="sync-progress">
      <div className="flex items-center mb-2">
        <RefreshCw className="h-5 w-5 text-blue-600 mr-2 animate-spin" />
        <span className="text-sm font-medium text-blue-900">{displayMessage}</span>
      </div>
      <div className="w-full bg-blue-200 rounded-full h-2 overflow-hidden">
        <div 
          className="bg-blue-600 h-2 rounded-full transition-all duration-300" 
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
    </div>
  );
};

